import React from "react";
import * as S from "src/constants/StringConstants";
interface RequirementInfoProps {
  reqDetails: any;
}

const RequirementInfo = ({ reqDetails }: RequirementInfoProps) => {
  return (
    <div>
      <h4 className="form-title">{S.APP_REQS_TITLE}</h4>
      <div className="app-builder__info-table mt-5 mb-5">
        <h5>{S.APP_REQS_ADD_FIELD_CASE_INFO}</h5>
        <div>
          <label>{S.APP_REQS_ADD_FIELD_CARRIER}:</label>
          <span>{reqDetails?.carrier || "-"}</span>
        </div>
        <div>
          <label>{S.APP_REQS_ADD_FIELD_PLAN}:</label>
          <span>{reqDetails?.plan || "-"}</span>
        </div>
        <div>
          <label>{S.APP_REQS_ADD_FIELD_POLICY}:</label>
          <span>{reqDetails?.policyNumber || "-"}</span>
        </div>
      </div>
    </div>
  );
};

export default RequirementInfo;
